import React from 'react'
import styles from './Team.module.css'


const Team = () => (
<div className="container">

<div className="row">
<h4 className="mt-1" style={{margin: "0 auto", color: "white"}}>Our Team</h4>
</div>

<div className="row justify-content-center">

<div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://avatars1.githubusercontent.com/u/34685781?s=460&u=74ef7ea83f1102f4fa3bfd9d7331b8ef66da8330&v=4"/>
    <h2>Josephine Dorado</h2>
    <p className={styles.who}>Full Stack Developer, 3D Ux</p>
    <p className={styles.membertext}>Josephine Dorado is an award-winning creative technologist with an entrepreneurial spirit and a focus on social impact and wellness. With a portfolio of work that has garnered multiple Fulbright awards and a MacArthur Foundation award in Digital Media & Learning, her focus is innovation in hybrid online spaces with a lens toward immersive learning and international cultural exchange.
    </p>
    
    <div className={styles.socicons}>
  
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/funksoup/"><i className="fab fa-linkedin-in"></i></a>
     
    </div>
    
  </div>
  </div>

  <div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://ca.slack-edge.com/TSVUWLRHS-UT0BZU52A-930e7aa6ae9c-512"/>
    <h2>Robert Han</h2>
    <p className={styles.who}>Full Stack Developer</p>
    <p className={styles.membertext}>Robert Han has a passion for unique UX/UI design while leveraging his diverse professional journey, from doing project management at one of the largest defense contractors and being ranked second nationwide at a top investment firm, to participating in and winning his first hackathon. He has a knack for thinking out of the box and develops with an entrepreneurial, business mindset.</p>
    <div className={styles.socicons}>
   
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/hanrobert/"><i className="fab fa-linkedin-in"></i></a>
  
    </div>
    
  </div>
  </div>

  <div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://cdn.glitch.com/c0dcb651-5b19-4756-a6e6-25b3982ca367%2Fmoi-2.jpg?v=1597010269116"/>
    <h2>Joyce Bettencourt</h2>
    <p className={styles.who}>3D Ux Designer</p>
    <p className={styles.membertext}>Joyce Bettencourt is co-founder of AvaCon, a nonprofit dedicated to promoting the growth and development of virtual worlds, XR and 3D immersive spaces. AvaCon were organizers of the Second Life Community Convention, Federal Consortium of Virtual Worlds, and the OpenSimulator Community Conference. She is also Creative Director of The Vesuvius Group, a collaborative studio developing online immersive learning and social environments.</p>
    
    <div className={styles.socicons}>
   
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/joycebettencourt/"><i className="fab fa-linkedin-in"></i></a>
  
    </div>
    
  </div>
  </div>

  </div>

  <div className="row justify-content-center">


<div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://cdn.glitch.com/f28949c6-6f44-4abb-a9a1-6a9e90371a91%2FIMG-20200729-WA0000_mh1596115301303.jpg?v=1596115348329"/>
    <h2>Caroline Ninganga</h2>
    <p className={styles.who}>Full Stack Developer</p>
    <p className={styles.membertext}>
A programmer with a background in healthcare and education. Effective at combining problem solving methods to build more intuitive web applications using React, Node.js and JavaScript. Recently, earned a certificate in full stack web development from Columbia University. Passionate about collaborating on projects which aim to best engage the audience through impactful user-experiences. 
</p>
    <div className={styles.socicons}>
  
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/carolineninganga/"><i className="fab fa-linkedin-in"></i></a>
     
    </div>
    
  </div>
  </div>

  <div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://avatars1.githubusercontent.com/u/20895?s=460&v=4"/>
    <h2>Jeroen Frans</h2>
    <p className={styles.who}>Web Engineer, 3D Ux</p>
    <p className={styles.membertext}>Jeroen Frans is a programmer and creative producer and has 15 years of experience in virtual world development. Jeroen is always looking forward to his professional journey to pick up and enhance innovative technology. This drives him to try his hand in many technologies, and his early adoption has resulted in a wide skill set in programming, 3D, Web and game design, machinima and animation.</p>
    
    <div className={styles.socicons}>
   
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/mrfrans/"><i className="fab fa-linkedin-in"></i></a>
  
    </div>
    
  </div>
  </div>

  <div className="col-md-4 mt-3">
  <div className={styles.member}>
    <img alt="phot" src="https://cdn.glitch.com/f28949c6-6f44-4abb-a9a1-6a9e90371a91%2F52837649.jpg?v=1596115147721"/>
    <h2>Yaheng Wu</h2>
    <p className={styles.who}>Full Stack Developer</p>
    <p className={styles.membertext}>Phoebe is an accountant and a web developer. As an accountant, her experience lies in reconciliations and P&L analysis, and she is capable of data wrangling and visualization through SQL, Python, and Tableau, while also skilled at coding in VBA to automate event processes. As a web developer, she focuses on building full stack web development projects using React, Node.js, MongoDB, and JavaScript.</p>
    
    <div className={styles.socicons}>
   
      <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/yahengwu/"><i className="fab fa-linkedin-in"></i></a>
  
    </div>
    
  </div>
  </div>




  </div>




</div>
)


export default Team;